/** N244 wizard — shared bits (Dean, 22 Oct 2026). */
export const STEPS = [
  { key: "order", label: "Order sought" },
  { key: "details", label: "Details & wording" },
  { key: "bundle", label: "Enclosures & generate" },
  { key: "send", label: "Send to court" },
];

export const TONE = {
  sky: "border-sky-300 bg-sky-50 text-sky-900",
  amber: "border-amber-300 bg-amber-50 text-amber-900",
  rose: "border-rose-300 bg-rose-50 text-rose-900",
  emerald: "border-emerald-300 bg-emerald-50 text-emerald-900",
  slate: "border-slate-400 bg-slate-100 text-slate-900",
};

export const errMsg = (e) => { const d = e?.response?.data?.detail; return (typeof d === "string" ? d : d?.message) || e.message; };
export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");
export const fmtSize = (n) => (n == null ? "" : n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
export const longDate = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "");

/** Blank form state for the wizard — the N244 block is what goes onto the official form. */
export const initialForm = (ctx) => {
  const p = ctx.prefill || {}; const d = ctx.defaults || {};
  return {
    order_type: "alt_service",
    fields: { process_server: d.process_server, methods: ["first class post"], trace: "no trace carried out", adjourn_days: "60", relist: true,
      hearing_date: p.hearing_date || "", hearing_time: p.hearing_time || "", service_address: p.debtor_address || "" },
    n244: {
      court_name: p.court_name || "", court_address: p.court_address || "", claim_number: p.claim_number || "", defendants: p.defendants || "",
      debtor_name: p.debtor_name || "", application_date: new Date().toISOString().slice(0, 10), hearing_mode: "without", evidence_mode: "box",
      hours: "", minutes: "", time_agreed: null, fixed_trial: "", judge_level: d.judge_level, serve_who: "", serve_address: "", vulnerable: false, vulnerable_text: "",
      q3: "", q10: "", claimant: d.claimant, applicant_name: d.applicant_name, applicant_position: d.applicant_position, fee_account: d.fee_account,
      address1: d.address1, address2: d.address2, town: d.town, county: d.county, postcode: d.postcode, phone: d.phone, email: d.email, your_reference: p.your_reference || "",
    },
    cover: { include: true, extra: "" },
    draft_order: { include: false, paragraphs: [] },
    appendices: [],
    override_reason: "",
    related_keys: [],
    ai_meta: null,
  };
};

export const showField = (f, fields) => !f.show_if || !!fields[f.show_if];
